import { ListTodo, LoaderCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import AmountCircle from '@/components/common/AmountCircle';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import hasItems from '@/lib/utils/hasItems';

import AnalysisAction from './AnalysisAction';

export default function AnalysisActions() {
  const { t } = useTranslation();

  const {
    analysis: { actions, isPollingAnalysis },
  } = useEmail();

  if (isPollingAnalysis) {
    return (
      <div className="flex items-center justify-center">
        <div className="text-muted-foreground my-4 flex items-center gap-2 text-sm">
          <LoaderCircle className="text-primary-500 size-4 animate-spin" />

          <span>{t('GENERATING_RECOMMENDATIONS')}</span>
        </div>
      </div>
    );
  }

  if (!hasItems(actions)) return null;

  return (
    <div
      className="flex flex-col gap-2 rounded-lg border p-2"
      data-onboarding-id="next-actions"
    >
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-1.5 text-sm">
          <ListTodo className="text-primary-500 size-4" />

          {t('RECOMMENDED_ACTIONS')}
        </p>

        <AmountCircle amount={actions.length} />
      </div>

      <div className="flex flex-col gap-2">
        {actions?.map((action) => (
          <AnalysisAction key={action.id} {...action} />
        ))}
      </div>
    </div>
  );
}
